import React, {useState, useEffect} from 'react'
// Styles
import './ctus.style.css'
// Action
import  { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
// Images
import NH_Logo from '../../assets/images/logo/nh-logo.png'
import FBIcon from '../../assets/images/icons/facebook.png'
import IGIcon from '../../assets/images/icons/ig.png'
import YTIcon from '../../assets/images/icons/youtube.png'
// Components
import Copyright from '../../components/Copyright'
import useLineLogin from '../../_actions/authLine/lineLogin'
import lineConfig from '../../_actions/authLine/lineConfig'

function ContactUs() {

    const [loading, setLoading] = useState(true);
    const [pageDetail, setPageDetail] = useState({
        title: '',
        detail: ''
    });

    useEffect(() => {
        dataInit();
    }, [])

    const dataInit = async() => {
        await useLineLogin(lineConfig.contact_us);
        await getInfoContactInit();
    }

    // ~~~~~~~~~~~~~~~~~~~~~~ (API) ~~~~~~~~~~~~~~~~~~~~~~ //
    const getInfoContactInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetInfoContact() 
            .then(res => {
                if(res.isSuccess === true)
                {
                    setPageDetail({
                        title: res.info.Title,
                        detail: res.info.Detail
                    });
                    setLoading(false);
                }
                // console.log(res);
            })
        })
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="ctus-container">
                {/* header banner */}
                <div className="logo">
                    <img src={NH_Logo} />
                </div>
                {/* header text */}
                <h1 className="header-text">{pageDetail.title}</h1>
    
                {/* order condition */}
                <div dangerouslySetInnerHTML={{__html: pageDetail.detail}}></div>

                {/* <div className="card">
                    <div className="item">
                        <p className="label">ที่อยู่</p>
                        <p className="t-blue t-bold">สำนักงานใหญ่ N Health (ซอยศูนย์วิจัย)</p>
                        <p className="t-black t-normal">2301/2 ถนน เพชรบุรีตัดใหม่ แขวง บางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310</p>
                    </div>
                    <div className="item">
                        <p className="label">เบอร์ติดต่อ</p>
                        <p className="t-black t-bold">02 762 4000</p>
                    </div>
                    <div className="item">
                        <p className="label">อีเมลติดต่อ</p>
                        <p className="t-black t-bold">nhealth-ecommerce@nhealth-asia.com</p>
                    </div>
                    <div className="item">
                        <p className="label">Social Media</p>
                        <div className="sc-items">
                            <div className="sc-item">
                                <img src={FBIcon} />     
                                <span className="t-black t-bold">N Health Thailand</span>
                            </div> 
                            <div className="sc-item">
                                <img src={YTIcon} />     
                                <span className="t-black t-bold">N Health</span>
                            </div> 
                            <div className="sc-item">
                                <img src={IGIcon} />     
                                <span className="t-black t-bold">N Health_asia</span>
                            </div> 
                        </div>
                    </div>
                </div> */}
                {/* Copyright */}
                <Copyright position={'fixed'} bgColor={'white'}/>
            </div>
        )
    }
}

export default ContactUs